// extracted by mini-css-extract-plugin
export var cardTitle = "_cf-1";
export var commentBubble = "_cf-e";
export var commentForm = "_cf-a";
export var commentInput = "_cf-b";
export var commentLabel = "_cf-d";
export var commentPrompt = "_cf-9";
export var csatCard = "_cf-0";
export var feedbackSection = "_cf-7";
export var starDisabled = "_cf-6";
export var starEmpty = "_cf-5";
export var starFilled = "_cf-4";
export var starWrapper = "_cf-3";
export var starsContainer = "_cf-2";
export var submittedComment = "_cf-c";
export var thankYouText = "_cf-8";